import { useRef } from 'react';

import { Capability } from './capabilityTypes';

function equal(prev: Capability[], next: Capability[]) {
  return prev.length === next.length && prev.every((v, i) => v === next[i]);
}

// Deep compare capability arrays to see if they have changed
export function useDeepMemo(value: Capability[]) {
  const ref = useRef<Capability[] | undefined>(undefined);

  if (!ref.current || !equal(ref.current, value)) {
    ref.current = value;
  }

  return ref.current;
}
